/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StudentRouteLinkItem from './StudentRouteLinkItem';
import ResponseToInterventionIcon from 'icons/ResponseToInterventionIcon';

const messages = defineMessages({
  title: {id: 'navigation.interventions'},
});

const InterventionsItem = () => (
  <StudentRouteLinkItem
    iconBefore={ResponseToInterventionIcon}
    route="midas/student/interventions"
    title={messages.title}
  />
);

export default InterventionsItem;
